import { render } from "./Card.vue?vue&type=template&id=32135466"
import script from "./Card.vue?vue&type=script&lang=js"
export * from "./Card.vue?vue&type=script&lang=js"

import exportComponent from "/home/dyam/Documentos/RACINGBIKE/mi-stock-alavision-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__